export default __webpack_public_path__ + "static/media/recreate.9498db30.svg";